import {
  addImage,
  addText,
  createPdfDocument,
  addQrCode,
  paragraphSize,
  setFont,
  textSpacing,
  x,
  y,
  subtitleSize,
} from '../pdf';
import LogoCiva from '../../resources/images/logo-civa.png';
import { DATE_FORMAT, TIME_FORMAT } from '../../config/locale';
import { tzNormalizeDate } from '../date';
import { padStart } from '../string';

const myX = x;
const initialY = y;
let myY = initialY;
const margin = 3;
const pageWidth = 210;
const pageHeight = 297;
const qrWidth = 30;
const qrHeight = 30;
let page = 1;

const printDocumentHeader = (doc, itinerary, parcelSegment) => {
  addImage(doc, LogoCiva, myX, 3, 35, 10);

  setFont(doc, 'bold', 'arial-bold');

  doc.setFontSize(subtitleSize);
  addText(
    doc,
    'LISTADO DE GUÍAS DE REMISIÓN REMITENTE',
    pageWidth / 2,
    (myY += 5),
    pageWidth,
  );

  doc.setFontSize(paragraphSize);

  doc.rect(160, myY - 5, 45, 15);
  addText(doc, 'TURISMO CIVA S.A.C', 195, myY, 80, 'right');
  addText(doc, 'RUC:', 170, (myY += 5), 30);
  addText(doc, '20102427891', 188, myY, 30);

  addText(doc, 'PAGINA:', 20, myY + 7.5, 40, 'right');
  addText(doc, `${page}`, 25, myY + 7.5, 30);

  doc.rect(x, (myY += 10), pageWidth - 10, 33);

  addText(doc, 'FECHA DE EMISIÓN:', 37.8, (myY += 8), 40, 'right');
  addText(
    doc,
    tzNormalizeDate({ date: itinerary.departureTime, format: DATE_FORMAT }),
    50,
    myY,
    30,
  );
  addText(doc, 'NÚMERO DE REGISTRO MTC:', 173, myY, 80, 'right');
  addText(doc, '1517538CNG', 190, myY, 30);

  addText(doc, 'NÚMERO BUS:', 173, (myY += textSpacing), 35, 'right');
  addText(
    doc,
    ` ${itinerary.trip.assignedRegisteredBus.companyBusId}`,
    190,
    myY,
    30,
  );

  const originText = `${parcelSegment.sourceLocation.name}`;
  const originWrappedText = doc.splitTextToSize(originText, 80);
  addText(doc, 'ORIGEN:', 21.5, myY, 30, 'right');
  doc.text(originWrappedText, 30, myY);
  myY += (originWrappedText.length - 1) * textSpacing;

  addText(doc, 'PLACA:', 172.4, (myY += textSpacing), 30, 'right');
  addText(
    doc,
    `${itinerary.trip.assignedRegisteredBus.licensePlate}`,
    190,
    myY,
    30,
  );
  const destinationText = `${parcelSegment.destinationLocation.name}`;
  const destinationWrappedText = doc.splitTextToSize(destinationText, 80);
  addText(doc, 'DESTINO:', 23, myY, 30, 'right');
  doc.text(destinationWrappedText, 30, myY);
  myY += (destinationWrappedText.length - 1) * textSpacing;

  let driverMy = myY;

  addText(doc, 'CONDUCTORES:', 152, (driverMy += textSpacing), 30, 'right');

  driverMy += textSpacing;
  itinerary.trip.driverAssignmentList.forEach((driver) => {
    const driveText = `${driver.driver.customer.fullName}`;
    const driverWrappedText = doc.splitTextToSize(driveText, 80);
    addText(doc, driverWrappedText, 170, driverMy, 80);
    driverMy += textSpacing;
  });

  addText(doc, 'FECHA SALIDA:', 31.2, (myY += textSpacing), 30, 'right');
  addText(
    doc,
    tzNormalizeDate({ date: itinerary.departureTime, format: DATE_FORMAT }),
    45,
    myY,
    30,
  );
  addText(doc, 'HORA SALIDA:', 30, (myY += textSpacing), 30, 'right');
  addText(
    doc,
    tzNormalizeDate({ date: itinerary.departureTime, format: TIME_FORMAT }),
    35,
    myY,
    30,
  );
  addText(doc, 'ID ITINERARIO:', 31.5, (myY += textSpacing), 40, 'right');
  addText(doc, `${itinerary.id}`, 40, myY, 100);
};

const printQr = async (doc, itinerary, billProcessList, parcelSegment) => {
  const qrSpacing = 8;
  const maxQrPerRow = Math.floor(
    (pageWidth + qrSpacing) / (qrWidth + qrSpacing),
  );
  const totalQrWidth = maxQrPerRow * qrWidth + (maxQrPerRow - 1) * qrSpacing;
  const initialX = (pageWidth - totalQrWidth) / 2;

  let currentX = initialX;
  let currentY = myY + margin * 4.5;
  const marginBottom = 10; // Bottom margin to avoid exceeding page limits

  let qrCount = 0;

  const tasks = billProcessList.map((item) => async () => {
    if (qrCount >= maxQrPerRow) {
      currentX = initialX;
      currentY += qrHeight + qrSpacing;
      qrCount = 0;
    }

    if (currentY + qrHeight + marginBottom > pageHeight) {
      doc.addPage();
      myY = initialY;
      page += 1;
      printDocumentHeader(doc, itinerary, parcelSegment);
      currentX = initialX;
      currentY = myY + margin * 4.5;
      qrCount = 0;
    }

    setFont(doc, 'bold');
    doc.setFontSize(8);
    addText(
      doc,
      ` ${item.guideDocumentSeries}-${padStart(item.guideDocumentCode, 7)}`,
      currentX + qrWidth / 2,
      currentY + 0.5,
      qrWidth,
      'center',
    );
    doc.setFontSize(9);

    await addQrCode(
      doc,
      item.pdfUrl,
      currentX,
      currentY + 1,
      qrWidth,
      qrHeight,
    );

    addText(
      doc,
      ` ${item.refDocumentSeries}-${padStart(item.refDocumentCode, 7)}`,
      currentX + qrWidth / 2,
      currentY + qrHeight + 3,
      qrWidth,
      'center',
    );

    currentX += qrWidth + qrSpacing;
    qrCount += 1;
  });

  await tasks.reduce(
    (promiseChain, currentTask) => promiseChain.then(() => currentTask()),
    Promise.resolve(),
  );

  myY = currentY;
};

const printSenderRemissionGuide = async (
  itinerary,
  carrierRemissionGuideList,
) => {
  const doc = createPdfDocument();

  const tasks = carrierRemissionGuideList.map(
    (carrierRemissionGuide, index) => async () => {
      const { parcelSegment, billProcessList } = carrierRemissionGuide;

      printDocumentHeader(doc, itinerary, parcelSegment);
      await printQr(doc, itinerary, billProcessList, parcelSegment);

      if (index !== carrierRemissionGuideList.length - 1) {
        doc.addPage();
        myY = initialY;
        page += 1;
      }
    },
  );

  await tasks.reduce(
    (promiseChain, currentTask) => promiseChain.then(() => currentTask()),
    Promise.resolve(),
  );

  window.open(doc.output('bloburl'), '_blank');

  myY = 5;
  page = 1;
};

export default printSenderRemissionGuide;
